/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Confirm_Storage_NoteInputs */

const en_embed_captions_confirm_storage_note = /** @type {(inputs: Embed_Captions_Confirm_Storage_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Storage includes file hosting for 14 days and download allowance. If you have questions about billing, please contact support@closedcaptioncreator.com`)
};

const fr_embed_captions_confirm_storage_note = /** @type {(inputs: Embed_Captions_Confirm_Storage_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le stockage inclut l'hebergement du fichier pendant 14 jours et l'allocation de telechargement. Si vous avez des questions sur la facturation, veuillez contacter support@closedcaptioncreator.com`)
};

const de_embed_captions_confirm_storage_note = /** @type {(inputs: Embed_Captions_Confirm_Storage_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Speicherplatz umfasst die Dateispeicherung für 14 Tage und ein Downloadlimit. Bei Fragen zur Abrechnung wenden Sie sich bitte an support@closedcaptioncreator.com.`)
};

const it_embed_captions_confirm_storage_note = /** @type {(inputs: Embed_Captions_Confirm_Storage_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lo spazio di archiviazione include l'hosting dei file per 14 giorni e il limite di download. Per domande sulla fatturazione, contattare support@closedcaptioncreator.com`)
};

const ru_embed_captions_confirm_storage_note = /** @type {(inputs: Embed_Captions_Confirm_Storage_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В стоимость хранилища входит размещение файлов на хостинге в течение 14 дней и лимит на скачивание. По вопросам оплаты обращайтесь по адресу support@closedcaptioncreator.com`)
};

const es_embed_captions_confirm_storage_note = /** @type {(inputs: Embed_Captions_Confirm_Storage_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El almacenamiento incluye alojamiento de archivos durante 14 días y límite de descarga. Si tiene alguna pregunta sobre la facturación, póngase en contacto con support@closedcaptioncreator.com.`)
};

const zh_cn2_embed_captions_confirm_storage_note = /** @type {(inputs: Embed_Captions_Confirm_Storage_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`存储空间包含14天的文件托管和下载次数。如有任何关于账单的问题，请联系support@closedcaptioncreator.com`)
};

const ja_embed_captions_confirm_storage_note = /** @type {(inputs: Embed_Captions_Confirm_Storage_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ストレージには、14日間のファイルホスティングとダウンロード容量が含まれます。お支払いについてご質問がある場合は、support@closedcaptioncreator.comまでお問い合わせください。`)
};

const hi_embed_captions_confirm_storage_note = /** @type {(inputs: Embed_Captions_Confirm_Storage_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्टोरेज में 14 दिनों के लिए फाइल होस्टिंग और डाउनलोड की सुविधा शामिल है। बिलिंग संबंधी किसी भी प्रश्न के लिए कृपया support@closedcaptioncreator.com पर संपर्क करें।`)
};

const pt_pt2_embed_captions_confirm_storage_note = /** @type {(inputs: Embed_Captions_Confirm_Storage_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O armazenamento inclui hospedagem de arquivos por 14 dias e permissão para downloads. Em caso de dúvidas sobre a cobrança, entre em contato com support@closedcaptioncreator.com.`)
};

/**
* | output |
* | --- |
* | "Storage includes file hosting for 14 days and download allowance. If you have questions about billing, please contact support@closedcaptioncreator.com" |
*
* @param {Embed_Captions_Confirm_Storage_NoteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_confirm_storage_note = /** @type {((inputs?: Embed_Captions_Confirm_Storage_NoteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Confirm_Storage_NoteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_confirm_storage_note(inputs)
	if (locale === "de") return de_embed_captions_confirm_storage_note(inputs)
	if (locale === "it") return it_embed_captions_confirm_storage_note(inputs)
	if (locale === "ru") return ru_embed_captions_confirm_storage_note(inputs)
	if (locale === "es") return es_embed_captions_confirm_storage_note(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_confirm_storage_note(inputs)
	if (locale === "ja") return ja_embed_captions_confirm_storage_note(inputs)
	if (locale === "hi") return hi_embed_captions_confirm_storage_note(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_confirm_storage_note(inputs)
	return en_embed_captions_confirm_storage_note(inputs)
});